import { ArrowBack } from "@mui/icons-material";
import { Divider, Grid, IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import MuiButton from "../../components/muibutton";
import { useNavigate, useParams } from "react-router-dom";
import { getAPIwithParams } from "../../services/basehttpAPI";


const ViewCustomer = () => {
  const navigate = useNavigate();
  const params = useParams();
  const custid = params.custid;
  const [dataList, setDataList] = useState(null);
  let navigationUrl = `/layout/editcustomer/${custid}`;

  const getCustomerProfilebyId = async () => {
    let url = "CustomerProfile/GetCustomerProfileById";
    const custModel = {
      id: custid,
    };
    const response = await getAPIwithParams(url, custModel);
    setDataList(response.responseData);
  };
  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));

  useEffect(() => {
    getCustomerProfilebyId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNavigation = () => {
    navigate(navigationUrl);
  }
  return (
    <Container maxWidth="lg">
          <Typography variant="h5" flexGrow={1} sx={{ pl: "24px" }}>
              {translatedText?.view_customer_profile}
      </Typography>
      <Paper
        sx={{
          width: "80%",
          mt: "20px",
          ml: "20px",
          mb: "20px",
        }}
      >
        <Box sx={{ height: "60px", backgroundColor: "#F4F7FC" }}>
          <Stack
            useFlexGap
            flexWrap="wrap"
            direction="row"
            spacing={{ xs: 0.5, sm: 2, md: 4 }}
            sx={{ paddingTop: "10px", mr: "10px" }}
          >
            <IconButton onClick={() => navigate("/layout/customerprofiles")}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h6" flexGrow={1} sx={{ pt: "5px" }}>
              {dataList?.customerName}
            </Typography>
            <MuiButton
              type="button"
                          text={translatedText.edit}//"Edit"
              color="warning"
              onClick={handleNavigation}
              show={true}
            />
          </Stack>
        </Box>
        <Grid container spacing={2} sx={{ m: "20px" }}>
          <Grid item xs={12} sm={12} md={3}>
            <span className="fontcolor label-txt">
              {dataList?.customerName}
            </span>
                      <div className="fontheadercolor label-txt">{translatedText?.indas_customer_name}</div>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <span className="fontcolor label-txt">{dataList?.indasId}</span>
                      <div className="fontheadercolor label-txt">{translatedText?.indas_customer_id}</div>
          </Grid>
        </Grid>
        <Divider />
        <Grid container spacing={2} sx={{ m: "20px", pb: "20px" }}>
          <Grid item xs={12} sm={12} md={4}>
            <Typography sx={{ mb: "10px", fontWeight: "600" }}>
              Connected Users
            </Typography>
            {dataList?.userCustomerDetail?.length > 0 ? (
              dataList?.userCustomerDetail?.map((x) => (
                <>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={6} lg={5}>
                      <span
                        className="fontcolor label-txt"
                        style={{ wordWrap: "break-word" }}
                      >
                        {x.fullName}{" "}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={7}>
                      <span className="fontheadercolor label-txt">
                        {" "}
                        {x.email}
                      </span>
                    </Grid>
                  </Grid>
                </>
              ))
            ) : (
                <Typography sx={{ ml: "10px" }}>{translatedText?.no_records_found}</Typography>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ViewCustomer;
